import qs from 'qs';
import { bizmatesApi } from '@/utils/bizmatesApi';

export default {
  namespaced: true,
  state() {
    return {
      pageUrl: null,
      trialLessonLoginSuccess: false,
      trialLessonCredentials: {
        companyName: null,
        email: null,
        expirationDate: null,
        id: null,
        valid: null
      },
      trialLessonLists: null,
      isTrialLessonCreated: false
    };
  },
  mutations: {
    getPageUrl(state, pageUrl) {
      state.pageUrl = pageUrl;
    },
    setTrialLessonCredentials(state, payload) {
      state.trialLessonCredentials = payload;
    },
    setTrialLessonLists(state, payload) {
      state.trialLessonLists = payload;
    },
    setTrialLessonLoginSuccess(state, success) {
      state.trialLessonLoginSuccess = success;
    },
    setTrialLessonCreated(state, success) {
      state.isTrialLessonCreated = success;
    }
  },
  actions: {
    getPageUrl({ commit }, pageUrl) {
      commit('getPageUrl', pageUrl);
    },
    setTrialLessonLoginSuccess({ commit }, success) {
      commit('setTrialLessonLoginSuccess', success);
    },
    async authenticateUser({ commit }, user) {
      await bizmatesApi.post(
        'sales/validate',
        qs.stringify(user),
        {},
        response => {
          commit('setTrialLessonCredentials', response.data.result);
        }
      );
    },
    async createLesson({ commit }, user) {
      await bizmatesApi.post(
        'sales/lesson',
        qs.stringify(user),
        {},
        response => {
          const hasData = response.data !== undefined && Object.keys(response.data).length > 0;
          commit('setTrialLessonCreated', hasData);
        }
      );
    },
    async getTrialLessonLists({ commit }, user) {
      await bizmatesApi.post('sales/list', qs.stringify(user), {}, response => {
        commit('setTrialLessonLists', response.data.items);
      });
    }
  }
};
